<template>
    <div class="container-fluid bg-white border rounded-3 p-4">
        <h2>{{ isEditing ? 'Edit' : 'New' }} Doctor Order</h2>
        <hr />

        <!-- Student selection -->
        <label>Client : {{ student.user?.name }}</label>

        <!-- Date -->
        <label>Admission Date : {{ $formatDate(student.admission_date) }}</label>
        <!-- <input type="date" v-model="form.date" class="form-control" /> -->

        <!-- Reasons using vue-multiselect -->
        <label>Reasons for Visit</label>
        <multiselect v-model="selectedReasons" :options="reasons" :multiple="true" :close-on-select="false"
            :clear-on-select="false" :preserve-search="true" placeholder="Select reasons" label="name" track-by="id"
            class="form-control p-0" />
        <div v-if="errors.reasons_json" class="text-danger">{{ errors.reasons_json[0] }}</div>

        <!-- Findings -->
        <label>Findings</label>
        <textarea v-model="form.findings" class="form-control"></textarea>
        <div v-if="errors.findings" class="text-danger">{{ errors.findings[0] }}</div>

        <!-- Diagnoses -->
        <!-- <label>Diagnoses</label>
        <div v-for="(d, i) in form.diagnoses" :key="i" class="d-flex mb-2">
            <input v-model="form.diagnoses[i]" class="form-control me-2" placeholder="Diagnosis" />
            <button class="btn btn-sm delete-btn" @click="form.diagnoses.splice(i, 1)">X</button>
        </div>
        <button class="btn btn-primary btn-sm" @click="form.diagnoses.push('')">+ Add Diagnosis</button> -->

        <!-- Plans -->
        <!-- Plans (Read-Only) -->
        <label class="mt-3">Treatment / Plan / Recommendations</label>
        <div v-for="(p, i) in form.plans" :key="i" class="mb-2 border p-2 rounded bg-light">
            <p class="mb-0">{{ p }}</p>
        </div>


        <!-- Medications -->
        <label class="mt-3">Medications including Indications</label>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Medication</th>
                    <th>Start Date</th>
                    <!-- <th>End Date</th> -->
                    <th>Indication</th>
                    <!-- <th>Action</th> -->
                </tr>
            </thead>
            <tbody>
                <tr v-for="(m, i) in form.medications" :key="i">
                    <td><input v-model="m.name" class="form-control" /></td>
                    <td><input v-model="m.start_date" type="date" class="form-control" /></td>
                    <!-- <td><input v-model="m.end_date" type="date" class="form-control" /></td> -->
                    <td><input v-model="m.indication" class="form-control" /></td>
                    <!-- <td><button class="btn btn-sm delete-btn" @click="form.medications.splice(i, 1)">X</button></td> -->
                </tr>
            </tbody>
        </table>
        <!-- <button class="btn btn-sm btn-primary"
            @click="form.medications.push({ name: '', start_date: '', end_date: '', indication: '' })">
            + Add Medication
        </button> -->

        <!-- Boolean selects -->
        <label class="mt-3">May Client continue to take medication from standing orders?</label>
        <select v-model="form.continue_previous_orders" class="form-control">
            <option :value="1">Yes</option>
            <option :value="0">No</option>
        </select>

        <label>Does client have permission to take medications upon discharge?</label>
        <select v-model="form.discharge_meds_permission" class="form-control">
            <option :value="1">Yes</option>
            <option :value="0">No</option>
        </select>

        <label>May Client continue all previous orders?</label>
        <select v-model="form.allow_standing_orders" class="form-control">
            <option :value="1">Yes</option>
            <option :value="0">No</option>
        </select>

        <!-- Action buttons -->
        <div class="mt-4">
            <button class="btn btn-success btn-sm" @click="submitForm">Save</button>
            <button class="btn btn-secondary btn-sm ms-2 delete-btn"
                @click="$router.push({ name: 'student-doctor-orders', params: { id: form.student_id } })">
                Cancel
            </button>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'

export default {
    components: { Multiselect },
    props: ['id'],
    data() {
        return {
            isEditing: false,
            student: {},
            reasons: [],
            selectedReasons: [],
            form: {
                student_id: '',
                date: '',
                findings: '',
                diagnoses: [''],
                plans: [''],
                medications: [],
                allow_standing_orders: false,
                discharge_meds_permission: false,
                continue_previous_orders: false,
            },
            errors: {},
        };
    },
    methods: {
        async fetchStudent() {
            const id = this.form.student_id || this.$route.query.student_id;
            if (!id) return;
            try {
                const res = await this.$api.get(`/students/${id}`);
                this.student = res.data;
                this.form.student_id = res.data.id;

                this.form.date = this.student.admission_date;
                if (this.form.medications.length == 0) {
                    this.form.medications.push({
                        'name': this.student.medicine_name + " (" + this.student.dose + "mg)",
                        'start_date': this.student.admission_date,
                        // 'start_date', 'end_date', 'indication'
                    });
                }

            } catch (e) {
                console.error("Failed to fetch student:", e);
            }
        },
        async fetchReasons() {
            const res = await this.$api.get('/reasons');
            this.reasons = Array.isArray(res.data)
                ? res.data.map(r => ({
                    id: r.id,
                    name: r.title,
                    treatment_plans: r.treatment_plans
                }))
                : [];
        },
        async fetchOrder() {
            const res = await this.$api.get(`/doctor-orders/${this.id}`);
            const order = res.data;
            this.form = {
                student_id: order.student_id,
                date: order.date,
                findings: order.findings,
                diagnoses: order.diagnoses.map(d => d.diagnosis),
                plans: order.plans.map(p => p.plan),
                medications: order.medications.map(m => ({
                    name: m.name,
                    start_date: m.start_date,
                    end_date: m.end_date,
                    indication: m.indication
                })),
                allow_standing_orders: order.allow_standing_orders,
                discharge_meds_permission: order.discharge_meds_permission,
                continue_previous_orders: order.continue_previous_orders,
            };

            const reasonLabels = JSON.parse(order.reason || '[]');
            this.selectedReasons = this.reasons.filter(r => reasonLabels.includes(r.name));
        },
        async submitForm() {
            const payload = {
                ...this.form,
                reason: JSON.stringify(this.selectedReasons.map(r => r.name || r)),
            };
            this.errors = {};
            if (this.$route.query.updateOnly) {
                payload.updateOnly = this.$route.query.updateOnly;
            }
            try {
                if (this.isEditing) {
                    await this.$api.put(`/doctor-orders/${this.id}`, payload);
                } else {
                    await this.$api.post('/doctor-orders', payload);
                }
                this.$router.push({ name: 'student-doctor-orders', params: { id: this.form.student_id } });
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                } else {
                    console.log(error);
                    alert('Something went wrong.');
                }
            }
        }
    },
    watch: {
        selectedReasons: {
            handler(newReasons) {
                const allPlans = newReasons.flatMap(reason => reason.treatment_plans || []);
                const newTitles = allPlans.map(p => p.title);
                this.form.plans = [...new Set(newTitles)];
            },
            deep: true
        }
    },
    async mounted() {
        await this.fetchReasons();

        const studentIdFromQuery = this.$route.query.student_id;
        if (studentIdFromQuery && !this.id) {
            this.form.student_id = studentIdFromQuery;
        }

        if (this.id) {
            this.isEditing = true;
            await this.fetchOrder();
        }

        await this.fetchStudent();

    }
};
</script>

<style scoped>
@import "vue-multiselect/dist/vue-multiselect.min.css";

.btn-sm {
    padding: 2px 8px;
    font-size: 0.8rem;
    height: 35px;
    margin-top: 8px;
}
</style>
